import { Brand } from "../Brand";

export function Footer() {
  return (
    <footer className="mt-auto border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
      <div className="max-w-[1400px] mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <Brand size="sm" />
        <p className="text-xs text-slate-400 dark:text-slate-500">
          © {new Date().getFullYear()} TCA Auditors · DebitFlow — Xero → Batching → Netcash
        </p>
      </div>
    </footer>
  );
}
